import { useEffect } from 'react';

const useScrollToTop = (dependencies = []) => {
  useEffect(() => {
    // Immediate scroll to top for instant feedback
    window.scrollTo(0, 0);
    
    // Also scroll the document element for better compatibility
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    
    // Scroll the body element as well
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Small delay to ensure DOM is ready, then smooth scroll
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 50);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, dependencies);
};

export default useScrollToTop;
